import React, { useContext } from 'react';

import { excApi, handleApiCall } from '@exchange-frontends/api';
import { useIsMounted } from '@exchange-frontends/custom-hooks';

import { useStore } from '../../../store';
import { UserDataContext } from '../../App';
import AcquireAppButton from './AcquireAppButton';
import { HeaderButtonsContext } from './HeaderButtons';

const CcFreeAppButton = () => {
  const { accessToken } = useContext(UserDataContext) ?? {};
  const isMounted = useIsMounted();

  const { setShowPluginAcquiredDialog, fetchCreativeCloudLink } = useContext(HeaderButtonsContext);
  const detailScreen = useStore((state) => state.detailScreen);
  const appId = detailScreen?.id;
  const versionId = detailScreen?.appVersionId;

  const acquireFreeApp = async () => {
    const handler = handleApiCall(excApi.createFreeEntitlements, { source: 'Exchange', appId, versionId, accessToken });
    await handler.run();
    if (isMounted.current) {
      useStore.setState({ acquired: true });
      setShowPluginAcquiredDialog(true);
      await fetchCreativeCloudLink('install');
    }
  };

  return <AcquireAppButton type="free" onPress={acquireFreeApp} />;
};

export default CcFreeAppButton;
